import * as React from 'react';

export const getNoteDocumentBodyText = (document: string) => {
  if (!document) {
    return '';
  }

  const body = [];
  const matchItems = document
    .replace(/\\n/g, '')
    .matchAll(/"(?:text|mention_value)": ?"(.*?)(?=")/g);

  if (!matchItems) {
    return '';
  }

  for (const matchItem of matchItems) {
    const [, text] = matchItem;
    if (text) {
      body.push(text);
    }
  }

  return body.join(' ');
};

export const useNoteDocumentBody = (document: string) => {
  return React.useMemo(() => getNoteDocumentBodyText(document), [document]);
};
